import {Component, OnInit} from '@angular/core';
import {finalize} from 'rxjs/operators';

import {EventService} from '@src/app/core/services/event.service';
import {GlobalEventsService} from '@src/app/services/global-events.service';
import {LinkShareAccessNudgeModalService} from './link-share-access-nudge-modal-modal.service';
import {ModalService} from '@src/app/core/services/modal.service';
import {ClientService} from '@src/app/core/services/client.service';

@Component({
  selector: 'app-link-share-access-nudge-modal',
  templateUrl: './link-share-access-nudge-modal.component.html',
  styleUrls: ['./link-share-access-nudge-modal.component.scss'],
})
export class LinkShareAccessNudgeModalComponent implements OnInit {
  isLoggedIn: boolean;
  busy: boolean;

  constructor(
    private linkShareAccessNudgeModalService: LinkShareAccessNudgeModalService,
    private eventService: EventService,
    private notification: GlobalEventsService,
    private modalService: ModalService,
    private clientService: ClientService
  ) {}

  ngOnInit(): void {
    this.isLoggedIn = !!this.clientService.id;
  }

  requestAccess(): void {
    this.busy = true;

    this.linkShareAccessNudgeModalService
      .request(this.eventService.eventId)
      .pipe(finalize(() => (this.busy = false)))
      .subscribe(() => {
        this.modalService.close();

        this.notification.ToastNotificationEvent.emit({
          message: 'Access Requested',
          autoHideDelay: 2000,
          title: 'Your request has been forwarded to the event admin(s).',
          classes: ['notification'],
        });
      });
  }
}
